import { ServiceApi } from '../serviceApi/serviceApi';
import { ActiveAuth } from "../auth";
import { config } from '../config';
import { telemetry } from "../telemetry";


const MUTATION_loginEventSession = `
  mutation LoginEventSession ($eventId: ID) {
    loginEventSession(eventId: $eventId)
  }
`;
async function _loginEventSession(gateway: ServiceApi, payload: { eventId?: string }): Promise<any> {
  return gateway.queryGraphQLWithErrors(MUTATION_loginEventSession, {
    variables: payload
  })
  .catch((err) => {
    // absorb & log
    //   this is a 'beacon';
    //   the caller should not have to deal with failure
    telemetry.error(err);
    return null;
  });
}

const MUTATION_logoutEventSession = `
  mutation LogoutEventSession ($eventId: ID) {
    logoutEventSession(eventId: $eventId)
  }
`;
async function _logoutEventSession(gateway: ServiceApi, payload: { eventId?: string }): Promise<any> {
  return gateway.queryGraphQLWithErrors(MUTATION_logoutEventSession, {
    variables: payload
  })
  .catch((err) => {
    // absorb & log
    //   this is a 'beacon';
    //   the caller should not have to deal with failure
    telemetry.error(err);
    return null;
  });
}


export async function executeNamedQuery(
  activeAuth: ActiveAuth,
  queryName: string,
  payload: Record<string, any>
): Promise<any> {
  const gatewayConfig = config.joyBlissGatewayConfig;
  const gateway = new ServiceApi(gatewayConfig, activeAuth);
  const payloadAsAny = <any>payload; // TODO:  make this stricter

  switch (queryName) {
    case "loginEventSession":
      return _loginEventSession(gateway, payloadAsAny);
    case "logoutEventSession":
      return _logoutEventSession(gateway, payloadAsAny);
    default:
      return Promise.reject(new Error(`no such query: "${queryName}"`));
  }
}
